import { useSearchParams } from 'react-router-dom'
import { inventorySectionsByKey } from '../constants/inventorySections'

const useInventoryNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const requestedView = searchParams.get('view') || ''
  const requestedMode = searchParams.get('mode') || ''
  const requestedModal = searchParams.get('modal') || ''
  const requestedUploadMode = searchParams.get('uploadMode') || ''
  const isLegacyUploadView = requestedView === 'uploads' || requestedModal === 'uploads'
  const resolvedView = requestedView === 'manual' || requestedView === 'transfer' ? 'operations' : requestedView
  const backgroundView = isLegacyUploadView ? 'uploads' : resolvedView
  const activeTab = inventorySectionsByKey[backgroundView]?.key || ''
  const activeOperationMode =
    requestedView === 'transfer' || requestedMode === 'transfer' ? 'transfer' : 'manual'
  const activeUploadMode =
    (requestedUploadMode || (isLegacyUploadView ? requestedMode : '')) === 'items' ? 'items' : 'initial-stock'
  const isUploadModalOpen = requestedModal === 'uploads'
  const isHubView = !inventorySectionsByKey[backgroundView]

  const closeUploadModal = () => {
    const nextParams = new URLSearchParams(searchParams)
    nextParams.delete('modal')
    nextParams.delete('uploadMode')
    nextParams.set('view', 'uploads')

    setSearchParams(nextParams)
  }

  const openUploadModal = mode => {
    const nextParams = new URLSearchParams(searchParams)
    nextParams.set('view', 'uploads')
    nextParams.set('modal', 'uploads')

    if (mode) {
      nextParams.set('uploadMode', mode)
    }

    setSearchParams(nextParams)
  }

  const navigateToSection = (key, mode) => {
    if (!key) {
      const nextParams = new URLSearchParams(searchParams)
      nextParams.delete('view')
      nextParams.delete('mode')
      nextParams.delete('modal')
      nextParams.delete('uploadMode')
      setSearchParams(nextParams)
      return
    }

    const nextParams = new URLSearchParams()
    nextParams.set('view', key)

    if (key === 'operations' && mode) {
      nextParams.set('mode', mode)
    }

    if (key === 'uploads' && mode) {
      nextParams.set('uploadMode', mode)
    }

    setSearchParams(nextParams)
  }

  return {
    activeSection: inventorySectionsByKey[backgroundView] || null,
    activeTab,
    activeOperationMode,
    activeUploadMode,
    isHubView,
    isUploadModalOpen,
    navigateToSection,
    openUploadModal,
    closeUploadModal
  }
}

export default useInventoryNavigation
